import { render, staticRenderFns } from "./SignatureTemplate8.vue?vue&type=template&id=faa39dda&"
import script from "./SignatureTemplate8.vue?vue&type=script&lang=js&"
export * from "./SignatureTemplate8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports